/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import moment from "moment";
import "../../CSS/general.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Placeholder from 'react-bootstrap/Placeholder';
import { InfoCircleFill } from 'react-bootstrap-icons';
import HelpModal from "./HelpMessagePopup";
import AccountInfoModal from "../AccountInfoIframe";
import LoaderGif from "../../images/365 loading.gif";
import { Modal as Bootstrapodal } from "react-bootstrap";
import { differenceInCalendarDays, parse } from 'date-fns';

const Overview = ({ org, orgName, userCount, diskSpace, priceModel, orgUserCount, repositories, actualOrgUserCount, currentStatus, creationDate, trialDate, effectiveDate, isAzureGuardianOnly, activeTab, trailUntil, url, orgId }) => {
    const [priceFeatureHeader, setPriceFeatureHeader] = useState('');
    const [priceFeatureInfoUrl, setPriceFeatureInfoUrl] = useState('');
    const [showPriceFeature, setShowPriceFeature] = useState(false);
    const [countUniqueLocations, setCountUniqueLocations] = useState([]);
    const [accountInfoUrl, setAccountInfoUrl] = useState("");
    const [directDebitPopUp, setDirectDebitPopUp] = useState(false);
    const [avoidNavBarTrigger, setAvoidNavTrigger] = useState(false);
    const [progress, setProgress] = useState("");

    useEffect(() => {
        const createDate = parse(creationDate, "dd-MM-yyyy", new Date());
        const trial = parse(trialDate, "dd-MM-yyyy", new Date());

        let totalDays = differenceInCalendarDays(trial, createDate);
        const today = new Date();
        let activeDays = differenceInCalendarDays(today, createDate) + 1;
        totalDays = isNaN(totalDays) ? 0 : totalDays;
        activeDays = isNaN(activeDays) ? 0 : activeDays;
        setProgress(`${activeDays} of ${totalDays}`);

    }, [creationDate, trialDate]);
    const diskSpaceCalculation = (userCount, diskSpace, planModelSpace) => {
        if (!isNaN(parseInt(planModelSpace))) {
            if (planModelSpace !== "0" && planModelSpace !== "") {
                const totalspace = parseInt(planModelSpace);
                const usedPercentage = (Math.round(diskSpace * 100) / 100).toFixed(2) / (totalspace * userCount) * 100;
                if (usedPercentage > 95) {
                    return <> <span id="ContentPlaceHolder1_lblOrgDiskSpace" style={{ color: 'red' }}> {(Math.round(diskSpace * 100) / 100).toFixed(2) + "/" + (totalspace * userCount) + "GB"}</span>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-diskspace">If you exceed your quota additional charges will apply at {
                            priceModel.features.find(feature => feature.featureType === "QUOTAOVER")?.featureValue === "False"
                                ? 0
                                : priceModel.features.find(feature => feature.featureType === "QUOTAOVER")?.featureValue} {priceModel.features.find(feature => feature.featureType === "QUOTAOVER").featureUnit}</Tooltip>}>
                            <InfoCircleFill />
                        </OverlayTrigger>
                    </>
                }
                else {
                    return <span id="ContentPlaceHolder1_lblOrgDiskSpace"> {(Math.round(diskSpace * 100) / 100).toFixed(2) + "/" + (totalspace * userCount) + "GB"}</span>
                }
            }
            else {
                return <span id="ContentPlaceHolder1_lblOrgDiskSpace"> {(Math.round(diskSpace * 100) / 100).toFixed(2)}</span>
            }
        }
        else {
            return <span id="ContentPlaceHolder1_lblOrgDiskSpace"> {(Math.round(diskSpace * 100) / 100).toFixed(2)}</span>
        }
    }
    const RenderLocation = (repositories) => {
        if (JSON.stringify(repositories) !== '{}') { 
        if (repositories && repositories.filter(item => item.objectstoragerepositories && item.objectstoragerepositories.amazonBucketS3Compatible && item.objectstoragerepositories.amazonBucketS3Compatible.id !== 0).length !== 0) {
            repositories.forEach((repo) => {
                if (repo.objectstoragerepositories.amazonBucketS3Compatible.id !== 0 && !countUniqueLocations.includes(`(${repo.objectstoragerepositories.amazonBucketS3Compatible.id}) ` + repo.objectstoragerepositories.amazonBucketS3Compatible.Location)) {
                    setCountUniqueLocations([...countUniqueLocations, `(${repo.objectstoragerepositories.amazonBucketS3Compatible.id}) ` + repo.objectstoragerepositories.amazonBucketS3Compatible.Location])
                }
            })
        }
    }
    }

    const hideAccountInfoIframe = () => {
        setAccountInfoUrl("");
        setDirectDebitPopUp(false);   
    };
    

    
    useEffect(() => {
        RenderLocation(repositories)
    }, [repositories]);


    useEffect(() => {
        
        const handleMessage = (event) => {
            const iframe = document.getElementById('AccountInfoId');
            if (iframe && event.data === 'changeUrl' && avoidNavBarTrigger) {
                hideAccountInfoIframe();
                setShowPriceFeature(true);
                setPriceFeatureHeader("Packages");
                setPriceFeatureInfoUrl(
                    `/PricingModel?orgId=${orgId}&orgName=${orgName}&resellerOnly=false&displayOnly=false&collapsed=false`
                );
            }
            else {
                console.log('Not Matched event conditions!');
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [avoidNavBarTrigger]);

    const uniqueLocations = new Set();
    return (<div className="card mt-1" id="overview" style={{ cursor: "default" }}>
        <div className="card-header p-1 d-flex align-items-center">
            <span className="SectionTitle ms-2" style={{ fontWeight: '500', width: '90%' }}>Overview - {orgName}</span>
            <div className="d-flex justify-content-end " style={{ width: '10%' }}>
                {!isAzureGuardianOnly && activeTab === "365" && 
                  <HelpModal about="Introduction.html" />}
                
            </div>
        </div>
        <div className="card-body p-3">
            {(userCount !== "" && priceModel) ? Object.keys(priceModel).length !== 0 ? (
                <div className="row pt-1 pb-1" style={{ fontSize:"14px" }}>
                    <div className="col-12 pe-0">
                        <b>Tenant Id:</b> <span id="ContentPlaceHolder1_lblOrganisationName">{(org.name) ? org.name : ""}</span><br />
                        <b>Oldest Restore Point:</b>  <span id="ContentPlaceHolder1_lblFirstBackup">{(org.firstBackuptime) ? moment(org.firstBackuptime).format("DD-MM-YYYY HH:mm:ss").toString() : ""}</span><br />
                    </div>
                    <div className="col-6 pe-0">
                        <b>Package:</b>  <span id="ContentPlaceHolder1_lblPriceModel">{priceModel ? (Object.keys(priceModel).length !== 0) ? priceModel.price.name : "N/A" : "N/A"}</span><br />
                        <b>Disk Space Used (GB): </b>{diskSpaceCalculation(userCount, diskSpace, priceModel ? (Object.keys(priceModel)?.length !== 0 && priceModel.features?.find(feature => feature.featureType === "QUOTA")?.length !== 0) ? priceModel.features?.find(feature => feature.featureType === "QUOTA")?.featureValue : "" : "")}<br />
                        {/*<b>Oldest Restore Point:</b>  <span id="ContentPlaceHolder1_lblFirstBackup">{(org.firstBackuptime) ? moment(org.firstBackuptime).format("DD-MM-YYYY HH:mm:ss").toString() : ""}</span><br/>*/}
                        <b>Primary Copy:</b>
                        {priceModel ? (Object.keys(priceModel).length !== 0 && priceModel.features?.find(feature => feature.featureType === "LOCALIMMUT")?.length !== 0 && priceModel.features?.find(feature => feature.featureType === "LOCALIMMUT")?.featureValue !== "") ? (<>  <span id="ContentPlaceHolder1_lblLocalImmutability">{priceModel.features?.find(feature => feature.featureType === "LOCALIMMUT")?.featureValue + ' ' + priceModel.features?.find(feature => feature.featureType === "LOCALIMMUT")?.featureUnit} </span> <br /></>) : (<>  <span id="ContentPlaceHolder1_lblLocalImmutability">30 Days</span> <br /></>) : (<>  <span id="ContentPlaceHolder1_lblLocalImmutability">30 Days</span> <br /></>)}
                        {/*<b>Org User Count:</b> <span id="ContentPlaceHolder1_lblOrgUserCount">{actualOrgUserCount ? actualOrgUserCount : "N/A"}</span><br />*/}
                        
                    </div>   
                    <div className="col-6 pe-0">
                        
                        <b>User Count:</b> <span id="ContentPlaceHolder1_lblUserCount">{userCount}{orgUserCount !== "" ? ` / ${orgUserCount}` : ""}</span><br />
                        <b>Secondary Copy: </b>
                        {priceModel ?
                            (Object.keys(priceModel).length !== 0 && priceModel.features?.find(feature => feature.featureType === "OLOCKIMMUT")?.length !== 0 && priceModel.features?.find(feature => feature.featureType === "OLOCKIMMUT")?.featureValue && priceModel.features.find(feature => feature.featureType === "OLOCKIMMUT").featureValue !== "")
                                ? (<> <span id="ContentPlaceHolder1_lblSecondCopyImmutability">{priceModel.features?.find(feature => feature.featureType === "OLOCKIMMUT")?.featureValue + ' ' + priceModel.features.find(feature => feature.featureType === "OLOCKIMMUT").featureUnit} </span></>)
                                : <OverlayTrigger overlay={<Tooltip id="tooltip-diskspace">Not available in your package</Tooltip>}>
                                    <span>N/A</span>
                                </OverlayTrigger>
                            : <OverlayTrigger overlay={<Tooltip id="tooltip-diskspace">Not available in your package</Tooltip>}>
                                <span>N/A</span>
                            </OverlayTrigger>}
                        <br />
                    </div>
                    <div className="col-12 pe-0 d-flex">
                        <b>Effective Date:</b>{" "}
                        <span id="ContentPlaceHolder1_lblEffectiveDate" style={{ marginLeft:"3px" }}>
                            {trailUntil > 0 && currentStatus.includes("TRIAL") ? (
                                <>
                                    <b style={{ color: "red" }}>Trial (Day {progress})</b>{" "}
                                    {trailUntil > 0 && url !== "" && (
                                        <button className="a-icon"
                                            onClick={() => {
                                                setDirectDebitPopUp(true);
                                                setAccountInfoUrl(url);
                                                setAvoidNavTrigger(true);
                                            }}
                                        >
                                            <span id="linkTitle">(Activate your account)</span>
                                        </button>
                                    )}

                                </>
                            ) : (
                                moment(effectiveDate, 'DD/MM/YYYY').format("DD-MM-YYYY")
                            )}
                        </span>
                        </div>
                    <div className="col-12 pe-0 d-flex">

                        <b className="me-2">Location:</b>
                        {repositories && repositories.filter(item => item.objectStorage && item.objectStorage.amazonBucketS3Compatible && item.objectStorage.amazonBucketS3Compatible.id !== 0).length === 0
                            ? <span> ---- </span>
                            :
                            countUniqueLocations.length > 4 ?
                                <OverlayTrigger overlay={<Tooltip>{Array.from(countUniqueLocations).join(' ')}</Tooltip>}>
                                    <div className="col-12 pe-0 d-flex">
                                        {repositories.map((repo, index) => {
                                            if (repo.objectStorage.amazonBucketS3Compatible.id !== 0 && !uniqueLocations.has(repo.objectStorage.amazonBucketS3Compatible.Location)) {
                                                uniqueLocations.add(repo.objectStorage.amazonBucketS3Compatible.Location);
                                                return (<div key={repo.objectStorage.amazonBucketS3Compatible.id}>
                                                    <span className="ContentPlaceHolder1_lblImmutabilityLocation me-2" key={`span_${index}_${repo.objectStorage.amazonBucketS3Compatible.id}`}>({repo.objectStorage.amazonBucketS3Compatible.id}) {repo.objectStorage.amazonBucketS3Compatible.Location}</span></div>
                                                );
                                            }
                                            else {
                                                return null;
                                            }
                                        })}
                                    </div>
                                </OverlayTrigger> :
                                <div className="col-12 pe-0 d-flex">
                                    {repositories.map((repo, index) => {
                                        if (repo.objectStorage.amazonBucketS3Compatible.id !== 0 && !uniqueLocations.has(repo.objectStorage.amazonBucketS3Compatible.Location)) {
                                            uniqueLocations.add(repo.objectStorage.amazonBucketS3Compatible.Location);
                                            if (uniqueLocations.size < 4) {
                                                return (<div key={repo.objectStorage.amazonBucketS3Compatible.id}>
                                                    <span className="ContentPlaceHolder1_lblImmutabilityLocation me-2" key={`span_${index}_${repo.objectStorage.amazonBucketS3Compatible.id}`}>({repo.objectStorage.amazonBucketS3Compatible.id}) {repo.objectStorage.amazonBucketS3Compatible.Location}</span></div>
                                                );
                                            }
                                            else {
                                                return null;
                                            }
                                        }
                                        else {
                                            return null;
                                        }
                                    })}
                                </div>


                        }
                        <br />
                    </div>
                </div>
            ): (
                    <div className="row pt-1 pb-1" >
                        <div className="col-12">
                            <Placeholder animation="wave">
                                <Placeholder xs={3} /> <Placeholder xs={5} />
                                <Placeholder xs={4} /> <Placeholder xs={5} />
                            </Placeholder>
                        </div>
                        <div className="col-6">

                            <div className="col-12">
                                <Placeholder animation="wave">
                                    <Placeholder xs={3} /> <Placeholder xs={4} />
                                </Placeholder>
                            </div>
                            <div className="col-12">
                                <Placeholder animation="wave">
                                    <Placeholder xs={7} /> <Placeholder xs={3} />
                                </Placeholder>
                            </div>
                            <div className="col-12">
                                <Placeholder animation="wave">
                                    <Placeholder xs={4} /> <Placeholder xs={3} />
                                </Placeholder>
                            </div>

                        </div>
                        <div className="col-6">
                            <div className="col-12">
                                <Placeholder animation="wave">
                                    <Placeholder xs={4} /> <Placeholder xs={3} />
                                </Placeholder>
                            </div>
                            <div className="col-12">
                                <Placeholder animation="wave">
                                    <Placeholder xs={4} /> <Placeholder xs={3} />
                                </Placeholder>
                            </div>
                            <div className="col-12">
                                <Placeholder animation="wave">
                                    <Placeholder xs={4} /> <Placeholder xs={5} />
                                </Placeholder>
                            </div>
                        </div>
                        <div className="col-12">
                            <Placeholder animation="wave">
                                <Placeholder xs={3} /> <Placeholder xs={5} />
                            </Placeholder>
                        </div>
                    </div>
            ) : (<div className="row pt-1 pb-1" >
                <div className="col-12">
                    <Placeholder animation="wave">
                        <Placeholder xs={3} /> <Placeholder xs={5} />
                        <Placeholder xs={4} /> <Placeholder xs={5} />
                    </Placeholder>
                </div>
                <div className="col-6">

                    <div className="col-12">
                        <Placeholder animation="wave">
                            <Placeholder xs={3} /> <Placeholder xs={4} />
                        </Placeholder>
                    </div>
                    <div className="col-12">
                        <Placeholder animation="wave">
                            <Placeholder xs={7} /> <Placeholder xs={3} />
                        </Placeholder>
                    </div>
                    <div className="col-12">
                        <Placeholder animation="wave">
                            <Placeholder xs={4} /> <Placeholder xs={3} />
                        </Placeholder>
                    </div>

                </div>
                <div className="col-6">
                    <div className="col-12">
                        <Placeholder animation="wave">
                            <Placeholder xs={4} /> <Placeholder xs={3} />
                        </Placeholder>
                    </div>
                    <div className="col-12">
                        <Placeholder animation="wave">
                            <Placeholder xs={4} /> <Placeholder xs={3} />
                        </Placeholder>
                    </div>
                    <div className="col-12">
                        <Placeholder animation="wave">
                            <Placeholder xs={4} /> <Placeholder xs={5} />
                        </Placeholder>
                    </div>
                </div>
                <div className="col-12">
                    <Placeholder animation="wave">
                        <Placeholder xs={3} /> <Placeholder xs={5} />
                    </Placeholder>
                </div>
            </div>)
            }

        </div>
        <AccountInfoModal displayModal={directDebitPopUp} noClose={false} closeModal={hideAccountInfoIframe} action="Account Management" url={accountInfoUrl} />
        <Bootstrapodal
            size="xl"
            show={showPriceFeature}
            onHide={(e) => {
                window.location.reload();
                setShowPriceFeature(false); 
            }}
            backdrop="static"
            aria-labelledby="main-popup"
            centered
            className="PriceFeature-modal"
        >
            <Bootstrapodal.Header closeButton>
                <Bootstrapodal.Title id="main-popup">
                    {priceFeatureHeader}
                </Bootstrapodal.Title>
            </Bootstrapodal.Header>
            <Bootstrapodal.Body className="p-0">

                {showPriceFeature ? <iframe id="AccountPriceFeatureId"
                    src={priceFeatureInfoUrl}
                    title="AccountPriceFeature"
                    sandbox="allow-scripts allow-same-origin"
                    style={{ height: "72vh", width: '100%', minWidth: "-webkit-fill-available" }}
                >  </iframe> :
                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                        <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                    </div>}
            </Bootstrapodal.Body>
        </Bootstrapodal>
    </div>
    );
}

export default Overview;